import { Dispatch } from 'react';
import { createContext } from 'use-context-selector';
import { PayloadAction } from 'typesafe-actions';
import { DeviceManagementState, DeviceManagementContextActionTypes } from './types';
import { defaultDeviceManagementState } from './defaultState';

const DeviceManagementContext = createContext<Partial<DeviceManagementState>>(defaultDeviceManagementState);
const DeviceManagementDispatchContext = createContext<
  Dispatch<PayloadAction<DeviceManagementContextActionTypes, any>> | undefined
>(undefined);

export { DeviceManagementContext, DeviceManagementDispatchContext };
